/**
 * Update donor details
 */
import Vue from 'vue';
import { getParameterByName } from "../../helpers";

const state = {
    update_details: {
        email: null,
        title: null,
        firstname: null,
        lastname: null,
        phone: null,
        address: null,
        state: null,
        city: null,
        postalcode: null,
        country: null,
        isProcessing: false
    }
}

const getters = {
    update_details: state => state.update_details,
}

const mutations = {
    mutate_firebase_user: (state, user) => {
        Object.assign(state.update_details, user)
    },
    updateDetail: (state, { field, value }) => {
        Vue.set(state.update_details, field, value);
    },
}

const actions = {
    create_firebase_record_from_emailaddress: (state) => {
        return Vue.http.post(`${wwfconfigs.WEB_API}/update-details/create`, {
            email: state.getters.update_details.email
        });
    },

    get_data_from_email_link: function (context) {
        return new Promise((resolve, reject) => {
            let n = getParameterByName("n");

            let decoden = "?" + window.atob(n);
            console.log("decodeq", decoden);
            let id = getParameterByName("id", decoden);
            let token = getParameterByName("token", decoden);
            if (id && token) {
                context.commit('updateDetail', {
                    field: "key",
                    value: id
                })
                context.commit('updateDetail', {
                    field: "token",
                    value: token
                })
                console.log('context.getters.update_details.key', context.getters.update_details.key)

                Vue.http.get(`${wwfconfigs.WEB_API}/update-details/public?detailsId=${id}`)
                    .then(response => {
                        if (response.body && response.body.email) {
                            console.log(response.body);
                            context.commit('mutate_firebase_user', response.body)
                            resolve(true);
                        } else {
                            console.log("empty", response.body);
                            resolve(false);
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            }
            else {
                resolve(false);
            }
        })
    },

    update_new_details_to_firebase: function (context) {
        return Vue.http.post(`${wwfconfigs.WEB_API}/update-details/commit`, {
            id: context.getters.update_details.key,
            public: {
                id: context.getters.update_details.key,
                email: context.getters.update_details.email,
                address: context.getters.update_details.address,
                city: context.getters.update_details.city,
                country: context.getters.update_details.country,
                state: context.getters.update_details.state,
                postalcode: context.getters.update_details.postalcode,
                firstname: context.getters.update_details.firstname,
                lastname: context.getters.update_details.lastname,
                phone: context.getters.update_details.phone,
                title: context.getters.update_details.title,
                isChanged: true
            }
        });
    },

    updateCreditCardDetails(context, data) {
        return new Promise((resolve, reject) => {
            Vue.http.post(`${wwfconfigs.WEB_API}/payment/tokenize`, {
                token: data.token,
                cardHolderName: data.cardHolderName,
                custRef: state.update_details.key
            }).then(response => {
                console.log("updateCreditCardDetails - SUCCESS - ", response);
                resolve(response.body);

            }).catch((error) => {
                console.error("updateCreditCardDetails - ERROR - ", error);
                state.update_details.isProcessing = false
                reject(error);
            });
        })
    },

    // Old Bambora checkout
    update_details_checkout({ dispatch, state, commit }) {
        state.update_details.isProcessing = true
        console.log('update_details_checkout', state)
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/updatedetailscheckout', {
                email: state.update_details.email,
                custRef: state.update_details.key
            }).then(response => {
                console.log("update_details_checkout", response)
                state.update_details.isProcessing = false
                // commit("updateDonation", {field : 'method', value: response.body.method});
                // commit("updateDonation", {field : 'url', value: response.body.url});
                resolve(response)
            }, error => {
                console.error("update_details_checkout", error)
                state.update_details.isProcessing = false
                reject(error)
            });
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/update_details.js